var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CBreadcrumb',{staticClass:"mb-0 border-bottom-0",attrs:{"items":_vm.breadcrumbs}})}
var staticRenderFns = []

export { render, staticRenderFns }